/**
 * Modified based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-redux/modules/reducer.js
 * we want to extend the location with `queryString`
 */
import * as queryString from 'query-string'
import { LocationChangeAction, RouterState } from 'react-router-redux'

import { ICommonLocation, IEnhancedLocation } from '../utils/location/types'
export {
  IQuery,
  ILocationParams,
  IEnhancedLocation
} from '../utils/location/types'

export interface IEnhancedRouterState extends RouterState {
  previousLocation: IEnhancedLocation | null
  location: IEnhancedLocation
}

export interface IState {
  location: IEnhancedLocation
  previousLocation: IEnhancedLocation | null
}

/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'

const initialState: IState = {
  location: {
    pathname: '/',
    search: '',
    hash: '',
    query: {},
    state: undefined
  },
  previousLocation: null
}

let isFirstRun = true

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
export const enhancedRouterReducer = (
  state = initialState,
  { type, payload }: LocationChangeAction
): IEnhancedRouterState => {
  if (type === LOCATION_CHANGE) {
    const location = {
      ...payload,
      query: queryString.parse(payload.search) || {}
    }

    /**
     * This reducer is run on server and client side. If we do not clear
     * previousLocation for first run, previousLocation will be equal location
     * which was set on server side. Which means that for first render
     * previousLocation and location would be exactly the same. previousLocation
     * should be null for first render since it is the first render
     */
    const previousLocation = isFirstRun ? null : state.location
    isFirstRun = false

    return {
      ...state,
      previousLocation,
      location
    }
  }

  return state
}
